export default {

    Signs: 'الموقع|الموفعين',
};
